import React from "react";
import Button from "components/Common/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createAlert } from "actions/alerts";
import isEmail from "validator/lib/isEmail";
import { updateBillingCustomer } from "./actions";
import "./style.scss";

class ModalBillingCustomer extends React.Component {
  handleSubmitBound = this.handleSubmit.bind(this);

  handleInputChange(field, e) {
    const objectToMerge = {};
    objectToMerge[field] = e.target.value;

    this.props.setState("MODAL_BILLING_CUSTOMER", objectToMerge);
  }

  handleSubmit() {
    if (isEmail(this.props.modalBillingCustomer.get("email"))) {
      this.props.updateBillingCustomer(this.props.modalBillingCustomer);
    } else {
      this.props.createAlert({ message: "Please enter a valid email." });
    }
  }

  render() {
    return (
      <div className="ModalBillingCustomer Modal__modal">
        <h5 className="Modal__title">
          Customer Information
        </h5>
        <div className="Modal__content">
          <section className="ModalBillingCustomer__section g-form__block">
            <div className="ModalBillingCustomer__section__input-container">
              <div className="ModalBillingCustomer__section__input-container__input">
                <label className="g-input__label" htmlFor="ModalBillingCustomer__contact-name">
                  Company Name
                </label>
                <input
                  type="text"
                  className="g-input"
                  placeholder="Vandelay Industries"
                  value={this.props.modalBillingCustomer.get("companyName")}
                  onChange={this.handleInputChange.bind(this, "companyName")}
                  id="ModalBillingCustomer__contact-name"
                />
              </div>
              <div className="ModalBillingCustomer__section__input-container__input">
                <label className="g-input__label" htmlFor="ModalBillingCustomer__email">
                  Email
                </label>
                <input
                  type="text"
                  className="g-input"
                  placeholder="fudd@looney.com"
                  value={this.props.modalBillingCustomer.get("email")}
                  onChange={this.handleInputChange.bind(this, "email")}
                  id="ModalBillingCustomer__email"
                />
              </div>
            </div>
            <div className="ModalBillingCustomer__section__input-container">
              <div className="ModalBillingCustomer__section__input-container__input">
                <label className="g-input__label" htmlFor="ModalBillingCustomer__phone">
                  Phone Number
                </label>
                <input
                  type="text"
                  className="g-input"
                  placeholder="+1 555 555 5555"
                  value={this.props.modalBillingCustomer.get("phoneNumber")}
                  onChange={this.handleInputChange.bind(this, "phoneNumber")}
                  id="ModalBillingCustomer__phone"
                />
                <p className="ModalBillingCustomer__section__input-container__input__description g-form__block__description">
                  Optional. We will only call you if you enter your phone number.
                </p>
              </div>
            </div>
          </section>
        </div>
        <div
          className="Modal__bottom ModalBillingCustomer__bottom"
        >
          <Button
            title="Update Customer Info"
            text="Update Customer Info"
            icon="Cloud"
            fillColor="white"
            disabled={this.props.modalBillingCustomer.get("isLoading") || !this.props.modalBillingCustomer.get("canSubmit")}
            isLoading={this.props.modalBillingCustomer.get("isLoading")}
            onClick={this.handleSubmitBound}
          />
        </div>
      </div>
    );
  }
}

function mapState(state) {
  const { billingPlan, modalBillingCustomer } = state;

  return {
    modalBillingCustomer,
    billingPlanRecord: billingPlan.get("record")
  };
}

function mapDispatch(dispatch) {
  return {
    createAlert: bindActionCreators(createAlert, dispatch),
    updateBillingCustomer: bindActionCreators(updateBillingCustomer, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(ModalBillingCustomer);

export default Connector;
